export default function toggleDataset (el: HTMLOrSVGElement, dataset: string, isEnabled: boolean): boolean {
  if (isEnabled) {
    el.dataset[dataset] = "";
  } else {
    delete el.dataset[dataset];
  }

  return isEnabled;
}
